module.exports = __webpack_public_path__ + "static/media/wifi.b3a57628.svg";